import { Suspense, ComponentType } from "react";
import { Box } from "@chakra-ui/react";
// import Loader from "../Loader";

function withSuspense(Component: ComponentType): JSX.Element {
  return (
    <Suspense fallback={Fallback()}>
      <Component />
    </Suspense>
  );
}

export const Fallback = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      h={"100vh"}
      minH={"100%"}
      justifyContent={"center"}
    >
      {/* <Loader /> */}
    </Box>
  );
};

export default withSuspense;
